import { useCallback } from 'react';
import { useShowPdfViewerModal } from '~/components/PdfViewerModal/pdfViewerModal';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
export function useViewInvoicePdf(param) {
    let { invoiceId, invoiceNumber } = param;
    const { api } = useStoreActions();
    const { t } = useLocaleKeys();
    const showPdfViewerModal = useShowPdfViewerModal();
    const viewInvoicePdf = useCallback(async function() {
        let { showDownloadButton } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        await showPdfViewerModal({
            biName: 'ad_hoc_invoice_pdf_viewer',
            title: t.adHocInvoiceApproval.invoiceSummary.invoicePdfTitle({
                invoiceNumber
            }),
            pdfUniqueName: invoiceId,
            getFileUrl: ()=>api.invoice.downloadPDF(invoiceId),
            showDownloadButton
        });
    }, [
        api.invoice,
        invoiceId,
        invoiceNumber,
        showPdfViewerModal,
        t.adHocInvoiceApproval.invoiceSummary
    ]);
    return {
        viewInvoicePdf
    };
}
